import apis from '../apis/apis'

const chungNhanTotNghiepTamThoiProcessor = {}
const controllerName = 'ChungNhanTotNghiepTamThoi'

chungNhanTotNghiepTamThoiProcessor.getAll = async ({
  truongId,
  skip,
  take,
  gioiTinh,
  trangThai,
  name,
}) => {
  const rs = await apis[controllerName].GetAll({
    param: `?skip=${skip}&take=${take}${truongId ? `&truongId=${truongId}` : ''}${
      gioiTinh ? `&gioiTinh=${gioiTinh}` : ''
    }${trangThai ? `&trangThai=${trangThai}` : ''}${name ? `&name=${name}` : ''}`,
  })
  return rs.isSuccess ? rs.data : { values: [], totalItemsCount: 0 }
}

chungNhanTotNghiepTamThoiProcessor.import = async (data, id) => {
  const rs = await apis[controllerName].Import({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
    data,
  })
  return rs
}

chungNhanTotNghiepTamThoiProcessor.upsert = async (data) => {
  let rs
  if (data.id) {
    rs = await apis[controllerName].Update({ method: 'post', responseType: 'text', data })
  } else {
    rs = await apis[controllerName].Create({ method: 'post', responseType: 'text', data })
  }
  return rs
}

chungNhanTotNghiepTamThoiProcessor.delete = async (id) => {
  const rs = await apis[controllerName].Delete({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
  })
  return rs
}

chungNhanTotNghiepTamThoiProcessor.deleteMany = async (data) => {
  const rs = await apis[controllerName].DeleteMany({
    method: 'post',
    responseType: 'text',
    data,
  })
  return rs
}

export default chungNhanTotNghiepTamThoiProcessor
